document.addEventListener("DOMContentLoaded", () => {

  // ----------------------------------------------------
  // 1) ALLE Quick-Add-Forms einblenden
  // ----------------------------------------------------
  const forms = document.querySelectorAll("form.quick-add-to-cart__form");
  forms.forEach(f => f.style.display = "");

  // ----------------------------------------------------
  // 2) Form-Submit für ALLE Quick-Add-Forms abfangen
  // ----------------------------------------------------
  document.addEventListener("submit", async (event) => {
    const form = event.target.closest("form.quick-add-to-cart__form");
    if (!form) return;

    event.preventDefault(); // verhindert Redirect auf /cart

    const btn = form.querySelector("[data-add-to-cart]");
    const formData = new FormData(form);

    try {
      // ------------------------------------------------
      // 3) Produkt via AJAX hinzufügen
      // ------------------------------------------------
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: formData
      });

      if (!response.ok) throw new Error("Fehler beim Add-to-Cart");

      const product = await response.json();

      // ------------------------------------------------
      // 4) Custom Events triggern
      // ------------------------------------------------
      document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
        detail: { product, addToCartBtn: btn }
      }));

      const scopedId = btn?.dataset?.scopedEventId;
      if (scopedId) {
        document.dispatchEvent(new CustomEvent(`ajaxProduct:added:${scopedId}`, {
          detail: { product, addToCartBtn: btn }
        }));
      }

      // ------------------------------------------------
      // 5) Cart Drawer öffnen
      // ------------------------------------------------
      const cartDrawer = document.querySelector("cart-drawer");

      if (cartDrawer?.open) {
        cartDrawer.open(); // Shopify Standard
      } else {
        // Fallback für Themes ohne .open()
        document.documentElement.classList.add("js-drawer-open");
        document.getElementById("CartDrawer")?.classList.add("is-open");
      }

    } catch (err) {
      console.error("Add-to-Cart Fehler:", err);
    }
  });

});